module.exports = new __parcel__URL__("../SVG/chevron-left.1679054d.svg").toString();